import { render, staticRenderFns } from "./ItemDetailsField.vue?vue&type=template&id=457c5eaf&scoped=true&"
import script from "./ItemDetailsField.vue?vue&type=script&lang=js&"
export * from "./ItemDetailsField.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailsField.vue?vue&type=style&index=0&id=457c5eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c5eaf",
  null
  
)

export default component.exports